import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import PoPrintModal from './PoPrintModal';
import POLogsModal from "./PoLogsModal";
import RepairPoServices from "../../../services/RepairPoServices";
import Spinner from 'react-bootstrap/Spinner';
import * as XLSX from "xlsx";

const SuperAdminPoList = () => {
  // user from localStorage (make sure structure matches your app)
  const user = JSON.parse(localStorage.getItem('userDetails') || '{}');
  const userEmail = user?.data?.user?.email;
  const [sortOrder, setSortOrder] = useState(null); // null, "asc", "desc"
  const [poAmountSortOrder, setPoAmountSortOrder] = useState(null); // null, 'asc', 'desc'


  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [sort, setSort] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [loading, setLoading] = useState(true);


  // Modal states (IMPORTANT: these must be declared)
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItem3, setSelectedItem3] = useState(null);

  // add this line near your other useState hooks
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [gridInsideModal3, setGridInsideModal3] = useState(false);
  const [selectedPOs, setSelectedPOs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);





  const options = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];

  // 👇 Move this OUTSIDE useEffect so you can reuse it
  const fetchPurchaseOrders = async (userRole) => {
    let status = 'Assigned-To-SuperAdmin'
    try {
      setLoading(true);
      const res = await RepairPoServices.AllPOByStatus(status);
      setPurchaseOrders(res?.data || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch purchase orders", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPurchaseOrders(); // ✅ call with current role
  }, [test]); // re-run if role or test changes



  const filteredSearch = purchaseOrders.filter((row) => {
    const search = searchTerm.toLowerCase();

    const repairOrderNo =
      row?.repairOrder?.repairOrderNo?.toString().toLowerCase() || "";

    const poNumber =
      row?.poNumber?.toString().toLowerCase() || "";

    const supplierName =
      row?.supplier?.name?.toLowerCase() || "";

    const storeName =
      row?.repairOrder?.store?.name?.toLowerCase() || "";

    const createdBy =
      row?.createdBy?.name?.toLowerCase() || "";

    const partNos =
      row?.items
        ?.map(i =>
          i?.repairItemId?.masterlist?.partNo?.toString().toLowerCase()
        )
        .join(" ") || "";

    const descriptions =
      row?.items
        ?.map(i =>
          i?.repairItemId?.masterlist?.description?.toLowerCase()
        )
        .join(" ") || "";

    return (
      repairOrderNo.includes(search) ||
      poNumber.includes(search) ||
      supplierName.includes(search) ||
      storeName.includes(search) ||
      createdBy.includes(search) ||
      partNos.includes(search) ||
      descriptions.includes(search)
    );
  });




  const pagination = Math.ceil(filteredSearch.length / sort);

  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  const handleViewClick = (poDetails) => {
    setSelectedItem(poDetails);       // set item to pass into modal
    setGridInsideModal(true);         // show modal
  };


  const handleViewLogs = (poDetails) => {
    setSelectedItem3(poDetails);       // set item to pass into modal
    setGridInsideModal3(true);         // show modal
  };

  const handleAssign = async (poId, action) => {
    try {
      let remark = "";

      // ✅ Only ask for remark if the action is "Send-Back"
      if (action === "Send-Back") {
        const { value } = await Swal.fire({
          title: "Enter Remark",
          input: "textarea",
          inputLabel: "Remark is required",
          inputPlaceholder: "Type your remark here...",
          inputAttributes: {
            "aria-label": "Type your remark here"
          },
          showCancelButton: true,
          confirmButtonText: "Submit",
          cancelButtonText: "Cancel",
          inputValidator: (value) => {
            if (!value) {
              return "Remark is required!";
            }
          }
        });

        if (!value) {
          return; // user cancelled or didn’t type
        }

        remark = value;
      }

      // ✅ Proceed with approval (no remark required)
      setLoading(true);

      const body = { poId, action, remark };
      const res = await RepairPoServices.approvePO(body);

      Swal.fire("Success", res.message, "success");

      // ✅ trigger refresh
      setTest((prev) => prev + 1);
      fetchPurchaseOrders();

    } catch (error) {
      console.error("Error in handleAssign:", error);
      Swal.fire("Error", error?.response?.data?.message || "Failed to update PO", "error");
    } finally {
      setLoading(false);
    }
  };


  // Toggle individual checkbox
  const handleCheckboxChange = (poId) => {
    setSelectedPOs(prev =>
      prev.includes(poId) ? prev.filter(id => id !== poId) : [...prev, poId]
    );
  };

  // Toggle select all
  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedPOs([]);
    } else {
      const allIds = filteredSearch
        .slice(activePag.current * sort, (activePag.current + 1) * sort)
        .map(po => po._id);
      setSelectedPOs(allIds);
    }
    setSelectAll(!selectAll);
  };

  // Bulk approve selected POs
  const handleBulkApprove = async () => {
    if (selectedPOs.length === 0) {
      Swal.fire("Warning", "Please select at least one PO to approve", "warning");
      return;
    }

    const confirm = await Swal.fire({
      title: `Approve ${selectedPOs.length} POs?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve All",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      for (const poId of selectedPOs) {
        await RepairPoServices.approvePO({ poId, action: "Approved" });
      }
      Swal.fire("Success", `${selectedPOs.length} POs approved successfully`, "success");
      setSelectedPOs([]);
      setSelectAll(false);
      fetchPurchaseOrders();
    } catch (error) {
      Swal.fire("Error", "Failed to approve selected POs", "error");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };



  // ✅ Download as Excel (with Amount & Total)
  const handleDownloadExcelWithAmount = () => {
  if (filteredSearch.length === 0) {
    Swal.fire("No Data", "No Repair Orders found to export!", "info");
    return;
  }

  const exportData = filteredSearch.map((row, index) => ({
    "#": index + 1,

    "Repair Request No":
      row?.repairOrder?.repairOrderNo || "N/A",

    "Repair Order No":
      row?.poNumber || "N/A",

    "Repair Order Amount":
      Number(row?.totalAmount || 0),

    "Repair Part No":
      row?.items
        ?.map(i => i?.repairItemId?.masterlist?.partNo || "N/A")
        .join(", "),

    "Repair Part Description":
      row?.items
        ?.map(i => i?.repairItemId?.masterlist?.description || "N/A")
        .join(", "),

    "Qty":
      row?.items
        ?.map(i => i?.approveQty || 0)
        .join(", "),

    "Rate":
      row?.items
        ?.map(i => i?.rate || 0)
        .join(", "),

    "Store":
      row?.repairOrder?.store?.name || "N/A",

    "Supplier":
      row?.supplier?.name || "N/A",

    "Supplier Address":
      row?.supplier?.address
        ? `${row.supplier.address.street || ""}, ${row.supplier.address.city || ""}, ${row.supplier.address.state || ""} - ${row.supplier.address.pincode || ""}, ${row.supplier.address.country || ""}`
        : "N/A",

    "Created At":
      new Date(row?.createdAt).toLocaleDateString("en-IN"),

    "Items Count":
      row?.items?.length || 0,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Repair Orders");

  XLSX.writeFile(workbook, "Repair_Orders_With_Amount.xlsx");

  Swal.fire("Success", "Repair Orders Excel downloaded successfully!", "success");
};




  // toggle sort order and sort the purchaseOrders
  const handleSortByDate = () => {
    let newOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);

    const sorted = [...purchaseOrders].sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return newOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

    setPurchaseOrders(sorted);
  };

  const handleSortByPoAmount = () => {
    const newOrder = poAmountSortOrder === "asc" ? "desc" : "asc";
    setPoAmountSortOrder(newOrder);

    const sorted = [...purchaseOrders].sort((a, b) => {
      const aAmount = Number(a?.totalAmount || 0);
      const bAmount = Number(b?.totalAmount || 0);

      return newOrder === "asc" ? aAmount - bAmount : bAmount - aAmount;
    });

    setPurchaseOrders(sorted);
  };


  return (
    loading ? (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner animation="border" role="status" variant="primary" />
        <p className="mt-2 fw-bold text-primary">Loading PO...</p>
      </div>
    ) : (
      <>

        <PoPrintModal
          show={gridInsideModal}
          onHide={() => setGridInsideModal(false)}
          item={selectedItem}
        />


        {gridInsideModal3 && selectedItem3 && (
          <POLogsModal
            show={gridInsideModal3}                     // ✅ correct modal state
            handleClose={() => setGridInsideModal3(false)} // ✅ close this modal only
            item={selectedItem3}                        // ✅ pass correct PO details
            test={setTest}
            handleAssign={handleAssign} // ✅ add this line
          />
        )}



        <div className="row">
          <div className="col-xl-12">

            {/* Filter */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
                <div className="tools">
                  <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Repair Request,Repair Order No, Part No, Description, Supplier, Store"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <Select
                          placeholder="Rows per page"
                          value={options.find(option => option.value === sort)}
                          onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title d-flex justify-content-between align-items-center">
                <div className="cpa">
                  <i className="fa fa-list me-2"></i>Approval Pending
                  <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                </div>
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={handleBulkApprove}
                    disabled={selectedPOs.length === 0}
                  >
                    <i className="fa fa-check me-1"></i>
                    Approve Selected ({selectedPOs.length})
                  </button>
                </div>
                <div className="d-flex align-items-right">


                  <button
                    className="btn btn-sm btn-primary me-2"
                    onClick={handleDownloadExcelWithAmount}
                  >
                    <i className="fa fa-download me-1"></i>Download Excel
                  </button>
                  <div className="tools">
                    <Link
                      to="#"
                      className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      onClick={() => setOpen2(!open2)}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Link>
                  </div>
                </div>
              </div>


              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div id="content_wrapper" className="dataTables_wrapper no-footer">
                        <div style={{
                          overflowX: 'auto',
                          overflowY: 'auto',
                          maxHeight: '400px',
                          whiteSpace: 'nowrap'
                        }}>
                          <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#fff", // White background
                                zIndex: 2,
                              }}
                            >
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                  /> Select All
                                </th>
                                <th>#</th>
                                <th>Request No.</th>
                                <th>Repair Order No.</th>
                                <th onClick={handleSortByPoAmount} style={{ cursor: "pointer" }}>
                                  Repair Order Amount{" "}
                                  {poAmountSortOrder === "asc" ? (
                                    <i className="fa fa-arrow-up text-primary ms-1"></i>
                                  ) : poAmountSortOrder === "desc" ? (
                                    <i className="fa fa-arrow-down text-primary ms-1"></i>
                                  ) : (
                                    <i className="fa fa-sort text-muted ms-1"></i>
                                  )}
                                </th>
                                <th onClick={handleSortByDate} style={{ cursor: "pointer" }}>
                                  CreatedAt{" "}
                                  {sortOrder === "asc" ? (
                                    <i className="fa fa-arrow-up text-primary ms-1"></i>
                                  ) : sortOrder === "desc" ? (
                                    <i className="fa fa-arrow-down text-primary ms-1"></i>
                                  ) : (
                                    <i className="fa fa-sort text-muted ms-1"></i>
                                  )}
                                </th>

                                <th>Repair Part No</th>
                                <th> Repair Part Description</th>
                                <th>Qty</th>
                                <th>Rate</th>
                                <th>Store</th>
                                <th>Suppplier</th>
                                <th>Deliver Address</th>


                                <th>Items</th>
                                <th>Print</th>
                                {['ravidagdi@gmail.com', 'dd@indigoinfraprojects.com', 'ajitindigo@gmail.com']
                                  .map(email => email.toLowerCase())
                                  .includes(userEmail?.toLowerCase()) && (
                                    <th className="text-center">Action</th>
                                  )}

                              </tr>
                            </thead>
                            <tbody>
                              {filteredSearch.length > 0 ? (
                                filteredSearch
                                  .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                  .map((row, index) => (
                                    <tr key={index}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          checked={selectedPOs.includes(row._id)}
                                          onChange={() => handleCheckboxChange(row._id)}
                                        />
                                      </td>
                                      <td>{activePag.current * sort + index + 1}</td>
                                      <td>{row?.repairOrder?.repairOrderNo || "N/A"}</td>
                                      <td>{row?.poNumber || 'N/A'}</td>
                                      <td>{Math.round(row?.totalAmount || 0)}</td>
                                      <td>{new Date(row?.createdAt).toLocaleDateString('en-IN')}</td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>
                                            {item?.partNo || "N/A"}
                                          </div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>
                                            {item?.description || "N/A"}
                                          </div>
                                        ))}
                                      </td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.approveQty || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.rate || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.repairOrder?.store?.name || "N/A"}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.supplier?.name || "N/A"}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.supplier?.address?.street}, {row?.supplier?.address?.city},
                                        <br />
                                        {row?.supplier?.address?.state} - {row?.supplier?.address?.pincode},
                                        <br />
                                        {row?.supplier?.address?.country}
                                      </td>

                                      <td>{row?.items?.length || 0}</td>
                                      <td>
                                        <button
                                          className="btn btn-success btn-xs"
                                          onClick={() => handleViewClick(row)}
                                        >
                                          Print{/*row?.items?.[0]?.supplier?.name || "Unknown Supplier"*/}
                                        </button>
                                      </td>
                                      {['ravidagdi@gmail.com', 'dd@indigoinfraprojects.com', 'ajitindigo@gmail.com']
                                        .map(email => email.toLowerCase())
                                        .includes(userEmail?.toLowerCase()) && (
                                          <td>
                                            <div className="d-flex gap-2 justify-content-center">
                                              <>

                                                <button
                                                  className="btn btn-primary d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                  style={{ width: '50px', borderRadius: '8px', height: '55px' }}
                                                  onClick={() => handleViewLogs(row)}
                                                >
                                                  <i className="fa-solid fa fa-eye text-white fs-5 mb-1"></i>
                                                  <span className="text-white" style={{ fontSize: '10px' }}>View</span>
                                                </button>
                                                <button
                                                  className="btn btn-warning d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                  style={{ width: "50px", borderRadius: "8px", height: "55px" }}
                                                  onClick={() => handleAssign(row?._id, "Send-Back")}
                                                >
                                                  <i className="fa-solid fa fa-eye text-white fs-5 mb-1"></i>
                                                  <span className="text-white" style={{ fontSize: '10px' }}>Maker</span>
                                                </button>
                                                <button
                                                  className="btn btn-warning d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                  style={{ width: "50px", borderRadius: "8px", height: "55px" }}
                                                  onClick={() => handleAssign(row?._id, "Approved")}
                                                >
                                                  <i className="fa-solid fa fa-eye text-white fs-5 mb-1"></i>
                                                  <span className="text-white" style={{ fontSize: '10px' }}>Approve</span>
                                                </button>
                                              </>


                                            </div>
                                          </td>

                                        )}

                                    </tr>
                                  ))
                              ) : (
                                <tr><td colSpan="16" className="text-center">No Purchase Orders Found</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {/* Pagination */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {filteredSearch.length > 0 ? (activePag.current * sort + 1) : 0} to{" "}
                            {Math.min(filteredSearch.length, (activePag.current + 1) * sort)} of {filteredSearch.length} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link className="paginate_button previous" to="#" onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}>
                              <i className="fa fa-angle-double-left"></i>
                            </Link>
                            <span>
                              {Array.from({ length: pagination }, (_, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                  onClick={() => onClick(i)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link className="paginate_button next" to="#" onClick={() => activePag.current < pagination - 1 && onClick(activePag.current + 1)}>
                              <i className="fa fa-angle-double-right"></i>
                            </Link>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </>
    )
  );

};

export default SuperAdminPoList;
